// extracted by mini-css-extract-plugin
export default {"card":"Admin_card__7LXG5","title":"Admin_title__QfF7t","actions":"Admin_actions__NzkdG","recordLabel":"Admin_recordLabel__mDaYS"};